import { render, staticRenderFns } from "./salaryDtl.vue?vue&type=template&id=6f184ddc&scoped=true&"
import script from "./salaryDtl.vue?vue&type=script&lang=js&"
export * from "./salaryDtl.vue?vue&type=script&lang=js&"
import style0 from "./salaryDtl.vue?vue&type=style&index=0&id=6f184ddc&prod&lang=scss&scoped=true&"
import style1 from "./salaryDtl.vue?vue&type=style&index=1&id=6f184ddc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f184ddc",
  null
  
)

export default component.exports